var _a, _b;
import React, { createContext, useEffect, useMemo, useState } from 'react';
import { NativeEventEmitter, NativeModules } from 'react-native';
import { light, dark } from '../../styles/vars/theme';
import { getComponentsGlobalStyle } from '../../styles/vars/size';
import merge from 'lodash.merge';
const defaultTheme = { light, dark };
export const ThemeContext = createContext({
    theme: defaultTheme.light,
    mode: 'light',
    componentStyle: getComponentsGlobalStyle(defaultTheme.light),
});
let defaultMode = 'light';
try {
    defaultMode = (_b = (_a = NativeModules === null || NativeModules === void 0 ? void 0 : NativeModules.KSAppearance) === null || _a === void 0 ? void 0 : _a.getColorScheme) === null || _b === void 0 ? void 0 : _b.call(_a);
}
catch (e) { }
function ThemeProvider({ theme = { light: {}, dark: {} }, children, mode: customMode, autoTheme = false, customTheme, }) {
    // 设置了暗黑模式跟随后，展示系统主题。用户手动设置的主题无需生效。
    const [mode, setMode] = useState(autoTheme ? defaultMode : customMode || 'light');
    const eventEmitter = useMemo(() => {
        if (NativeModules.KSAppearance) {
            return new NativeEventEmitter(NativeModules.KSAppearance);
        }
        return null;
    }, []);
    useEffect(() => {
        if (autoTheme && eventEmitter) {
            const colorListener = eventEmitter.addListener('ksAppearanceChanged', ({ colorScheme }) => {
                setMode(colorScheme);
            });
            return () => {
                colorListener.remove();
            };
        }
    }, [autoTheme, eventEmitter]);
    const modeTheme = useMemo(() => {
        const _light = Object.assign(Object.assign({}, light), theme.light);
        const _dark = Object.assign(Object.assign({}, dark), theme.dark);
        return mode === 'dark' ? _dark : _light;
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [mode]);
    const componentStyle = useMemo(() => {
        const baseStyle = getComponentsGlobalStyle(modeTheme);
        if (!(customTheme === null || customTheme === void 0 ? void 0 : customTheme.componentStyle)) {
            return baseStyle;
        }
        return merge(baseStyle, customTheme === null || customTheme === void 0 ? void 0 : customTheme.componentStyle);
    }, [customTheme === null || customTheme === void 0 ? void 0 : customTheme.componentStyle, modeTheme]);
    return (React.createElement(ThemeContext.Provider, { value: { theme: modeTheme, mode, componentStyle } }, children));
}
export default ThemeProvider;
